<template>
  <Layout>
    <div class="mc-list-header">
      <PageHeader :title="title" :items="items" class="mc-page-three" />

      <div class="clearfix mc-btn-group__list mc-btn-group__list--detail">
        <div class="float-end">
          <McButtonBack />
        </div>
      </div>
    </div>

    <!-- Table -->
    <div class="table-responsive my-3">
      <McGrapqlTable
        :apiClient="query"
        :fields="fields"
        :hasCheckbox="false"
        :searchable="true"
        :withCard="true"
      >
        <template #cell(time)="data">
          {{ data.value ? momentDMY_HI(data.value) + ' WIB' : '' }}
        </template>
        <template #cell(entity)="data">
          <strong class="td__noellipsis"> {{ data.value }}</strong>
        </template>
        <template #cell(action)="data">
          <strong class="td__noellipsis"> {{ data.value }}</strong>
        </template>
        <template #cell(detail)="data">
          <strong class="td__noellipsis"> {{ data.value }}</strong>
        </template>
      </McGrapqlTable>
    </div>
  </Layout>
</template>

<script>
import appConfig from '@/app.config'
import PageHeader from '@/components/page-header'
import Layout from '@/router/layouts/main'
import McGrapqlTable from '@/components/McGrapqlTable'
import McButtonBack from '@/components/McButtonBack'
import {
  LOG_SERVICE_CATEGORY,
  LOG_SERVICE_ACTION,
  LOG_SERVICES,
} from '@/services/api/maintenance/log'
import { Helper } from '@/mixin/helper'

/**
 * Starter component
 */
export default {
  page: {
    title: 'Servis',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    McGrapqlTable,
    McButtonBack,
  },

  mixins: [Helper],

  data() {
    return {
      show_model: [],
      data: [],
    }
  },

  computed: {
    title() {
      return `${this.$t('global.historyUpdate')}`
    },

    items() {
      return [
        {
          text: this.$t('global.setting'),
          to: '/setting/',
        },
        {
          text: this.$t('maintenance.breadCrumb.first'),
          to: '/setting/maintenance/',
        },
        {
          text: this.$t('maintenance.breadCrumb.second'),
          to: '/setting/maintenance/service',
        },
        {
          text: this.$t('global.historyUpdate'),
          active: true,
        },
      ]
    },

    fields() {
      return [
        {
          key: 'time',
          label: this.$t('global.time'),
          sortable: true,
          thClass: 'mc-table--250',
          isRedirectable: false,
        },
        {
          key: 'entity',
          label: this.$t('maintenance.field.compName'),
          sortable: true,
          class: this.$route.params.type === 'services' || 'd-none',
        },
        {
          key: 'action',
          label: this.$t('global.changeDescription'),
          sortable: true,
        },
        {
          key: 'detail',
          label: this.$t('global.information'),
          sortable: true,
        },
        {
          key: 'user',
          label: this.$t('global.changed'),
          sortable: true,
        },
      ]
    },

    query() {
      return {
        get: async (filter) => {
          return this.get(filter)
        },
      }
    },
  },

  methods: {
    async get(filter) {
      const type = this.$route.params.type
      let query, resName
      switch (type) {
        case 'category':
          query = LOG_SERVICE_CATEGORY
          resName = 'serviceCategoryAuditLogs'
          break
        case 'actions':
          query = LOG_SERVICE_ACTION
          resName = 'serviceActionAuditLogs'
          break
        case 'services':
          query = LOG_SERVICES
          resName = 'serviceAuditLogs'
          break
        default:
          break
      }

      const res = await this.$apollo.query({
        query: query,
        fetchPolicy: 'no-cache',
        variables: {
          filter: {
            ...filter,
          },
        },
      })

      const result = {
        data: res.data[resName][resName].data,
        pagination: res.data[resName][resName].pagination,
      }

      this.data = res.data[resName][resName].data

      return result
    },
  },
}
</script>
